
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, OnDestroy } from '@angular/core';
import { AsmComponentService } from '@spartacus/asm/components';
import { FeatureModulesService, TranslatePipe, User } from '@spartacus/core';
import {
   LaunchDialogService } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, Subscription } from 'rxjs';
import { SikoButtonComponent } from '@siko/components/atomic';
import { SikoB2bAsmBindCartComponent } from '@siko/features/asm/components/asm-bind-cart/asm-bind-cart.component';

@Component({
   selector: 'siko-b2b-customer-emulation',
   imports: [SikoB2bAsmBindCartComponent, AsyncPipe, TranslatePipe, SikoButtonComponent],
   templateUrl: './customer-emulation.component.html',
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SikoB2bCustomerEmulationComponent implements OnInit, OnDestroy {
   customer?: User;

   isCustomerEmulationSessionInProgress$?: Observable<boolean | undefined>;

   protected subscription = new Subscription();

   constructor(
      protected asmComponentService: AsmComponentService,
      protected userAccountFacade: UserAccountFacade,
      protected launchDialogService?: LaunchDialogService,
      protected featureModules?: FeatureModulesService
   ) {}

   ngOnInit(): void {
      this.subscription.add(
         this.userAccountFacade.get().subscribe(user => {
            if (user) {
               this.customer = user;
            }
         })
      );
      this.isCustomerEmulationSessionInProgress$ = this.asmComponentService.isCustomerEmulationSessionInProgress();
   }

   logoutCustomer(): void {
      this.asmComponentService.logoutCustomer();
   }

   ngOnDestroy(): void {
      this.subscription.unsubscribe();
   }
}
